module.exports = __webpack_public_path__ + "static/media/logo.11dcaa6d.png";